export class ModelNews {

  constructor(props) {
    this.id =   props['id'] || '';
    this.idCategory =   props['idCategory'];
    this.linkPhoto =  props['linkPhoto'];
    this.title = props['title'];
    this.date =  new Date(props['dateCreated']).toLocaleDateString('es')
    this.description = props['description'];
  }
}